import { FaultRow } from 'components/tables/data/fault/types';
import DeviceNameBreadcrumbs from 'components/DeviceNameBreadcrumbs';

/**
 * Column for the device name.
 */
export default function DeviceNameColumn({ data: { device } }: { data: FaultRow }) {
  return <DeviceNameBreadcrumbs {...device!} />;
}
